import React from 'react';
import { Box, IconButton } from '@mui/material';
import { motion } from 'framer-motion';
import CloseIcon from '@/public/icons/files/close.svg';
import AIPanel from './AIPanel';

interface AIPanelSidebarProps {
  onClose: () => void;
}

const AIPanelSidebar: React.FC<AIPanelSidebarProps> = ({ onClose }) => {
  return (
    <motion.div
      initial={{ width: 0, opacity: 0 }}
      animate={{ width: 450, opacity: 1 }}
      exit={{ width: 0, opacity: 0 }}
      transition={{
        type: 'spring',
        damping: 32,
        stiffness: 200,
        mass: 0.9,
      }}
      style={{
        height: '100%',
        overflow: 'hidden',
        borderLeft: '1px solid #E7E9EC',
      }}
    >
      <Box
        sx={{
          width: '450px',
          height: '100%',
          backgroundColor: '#FFFFFF',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        {/* Close Button */}
        <Box
          sx={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            zIndex: 10,
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{
              width: '36px',
              height: '36px',
              borderRadius: '8px',
              '&:hover': {
                backgroundColor: '#F5F5F5',
              },
            }}
          >
            <CloseIcon width={20} height={20} />
          </IconButton>
        </Box>

        {/* AI Panel Content */}
        <AIPanel />
      </Box>
    </motion.div>
  );
};

export default AIPanelSidebar;
